import RestDelete from "./delete";
import RestGet from "./get";
import RestPost, { RestPosMultiPartFile } from "./post";
import RestPut from "./put";

export async function getCatalogSectors() {
  return await RestGet("/api/catalog/catalogs?catalogTypeId=2");
}

export async function getCatalogSubSectors() {
  return await RestGet("/api/catalog/catalogs?catalogTypeId=3");
}

export async function getCatalogGroups() {
  return await RestGet("/api/catalog/catalogs?catalogTypeId=1");
}

export async function getCatalogCategories() {
  return await RestGet("/api/catalog/catalogs?catalogTypeId=6");
}

export async function reportMolecularCompound(data) {
  return await RestPost("/api/report/reportMolecularCompound", data);
}

export async function getQuarters(year) {
  return await RestGet("/api/saleProductQuarter/quarterComplete?year=" + year);
}

export async function reportMolecularCompoundDetail(data) {
  return await RestPost("/api/report/reportMolecularCompoundDetail", data);
}

export async function user() {
  return await RestGet("user");
}

export async function getSalesSummaryByYear(year) {
  return await RestGet("/api/report/reportCompanies/" + year + "/QUARTER/ALL");
}

export async function getSalesSummaryBySector(year) {
  return await RestGet("/api/report/reportCompanies/" + year + "/SECTOR/ALL");
}

export async function companies() {
  return await RestGet("/api/company/companies");
  //   return [    {
  //     "id": 174326,
  //     "code": "ABC",
  //     "name": "TEST TEMPORAL",
  //     "representative": "Noel Diaz",
  //     "telephone": "123456789",
  //     "laboratories": [
  //         {
  //             "id": 174327,
  //             "code": "A1",
  //             "name": "LAB TEST TEMPORAL"
  //         }
  //     ]
  // }]
}

export async function createCompany(body) {
  // :param body: {
  //   "name": "TEST TEMPORAL",
  //   "code": "ABC",
  //   "representative": "Noel Diaz",
  //   "telephone": "123456789",
  //   "laboratories": [{
  //     "code": "A1",
  //     "name": "LAB TEST TEMPORAL"
  //   }]
  // }
  return await RestPost("/api/company/", body);
}

export async function updateCompany(idCompany, body) {
  // :param body: {
  //   "id": 174326,
  //   "name": "TEST TEMPORAL",
  //   "code": "ABC",
  //   "representative": "Noel Diaz",
  //   "telephone": "123456789",
  //   "laboratories": [{
  //     "id": 174327,
  //     "code": "A1",
  //     "name": "LAB TEST TEMPORAL"
  //   }]
  // }
  return await RestPut("/api/company/updateCompany?idCompany=" + idCompany, body);
}

export async function deleteCompany(idCompany) {
  return await RestDelete("/api/company/deleteCompany?idCompany=" + idCompany);
}

export async function reportDetailCompanySales(companyId, year) {
  return await RestGet("/api/report/reportDetailCompanySales/" + companyId + "/" + year);
}

export async function reportCompareCompanySales(companyId, year, sectorId, subSectorId) {
  let url = "/api/report/reportCompareCompanySales?companyId=" + companyId + "&year=" + year;
  if (sectorId) {
    url += "&sectorId=" + sectorId;
  }
  if (subSectorId) {
    url += "&subSectorId=" + subSectorId;
  }
  return await RestGet(url);
}

export async function analysisVeterinaryMarket(data) {
  return await RestPost("/api/report/analysisVeterinaryMarket", data);
}

export async function TopSuperIntendenciaCompaniesPerYear(year) {
  let url = "/api/sale/top10?year=" + year;
  return await RestGet(url);
}

export async function countStoresByProvince() {
  return await RestGet("/api/store/countStoresByProvince");
  // return [
  //   [
  //       1,
  //       "AZUAY",
  //       "01",
  //       291
  //   ]]
}

export async function countStoresByCantonAndProvince(provinceCode) {
  return await RestGet("/api/store/countStoresByCantonAndProvince?provinceCode" + provinceCode);
}

export async function provinces() {
  return await RestGet("/api/province/provinces");
}

export async function storesjoined() {
  return await RestGet("/api/store/storesjoined");
}

export async function cantonsByProvince(provinceId) {
  return await RestGet("/api/province/cantonsByProvince?provinceId=" + provinceId);
}

export async function storesByProvinceId(provinceId) {
  return await RestGet("/api/store/storesByProvinceId?provinceId=" + provinceId);
}

export async function parroquiasByCanton(cantonId) {
  return await RestGet("/api/canton/parishesByCanton?cantonId=" + cantonId);
  // [
  //   {
  //     active: true,
  //     cantonId: 1,
  //     code: "010151",
  //     createdDate: 1624964435,
  //     idParish: 16,
  //     modifiedDate: 1624964435,
  //     name: "BAÑOS",
  //   },
  // ];
}

export async function storesByCantonId(cantonId) {
  return await RestGet("/api/store/storesByCantonId?cantonId=" + cantonId);
}

export async function storesByParroquias(parroquiaId) {
  return await RestGet("/api/parish/storesByParish?parishId=" + parroquiaId);
}

export async function updateStore(idStore, data) {
  // {
  //   "id": 12,
  //   "parish": {
  //     "createdDate": 1624964435,
  //     "modifiedDate": 1624964435,
  //     "idParish": 3,
  //     "cantonId": 1,
  //     "name": "EL BATAN",
  //     "code": "010103",
  //     "active": true
  //   },
  //   "parishId": 3,
  //   "code": "AL00011",
  //   "identifier": "0101132066001",
  //   "businessName": "SAETAMA MOROCHO MIGUEL IGNACIO",
  //   "areaName": "Insumos",
  //   "legalRepresentative": "SAETAMA MOROCHO MIGUEL IGNACIO",
  //   "technicalRepresentative": "SAETAMA GUALLPA DIANA ALEJANDRA",
  //   "address": "Rafael Estrella 2-79 y Ernesto Lopez",
  //   "reference": "sector feria libre"
  // }
  let url = "/api/store/updateStore?idStore=" + idStore;
  return await RestPut(url, data);
}

export async function addStore(body) {
  // {
  //   "parish": {
  //     "createdDate": 1624964435,
  //     "modifiedDate": 1624964435,
  //     "idParish": 928,
  //     "cantonId": 178,
  //     "name": "IÑAQUITO",
  //     "code": "170112",
  //     "active": true
  //   },
  //   "parishId": 928,
  //   "code": "860127",
  //   "identifier": "17580525",
  //   "businessName": "Noel Diaz",
  //   "areaName": "Manosca",
  //   "legalRepresentative": "Noel Diaz",
  //   "technicalRepresentative": "Noel Diaz",
  //   "address": "N36-53",
  //   "reference": "CC Manosca"
  // }
  return await RestPost("/api/store", body);
}

export async function getUsers() {
  return await RestGet("/api/user/users");
  //   return list of [    {
  //     "id": 145693,
  //     "email": "sguevara@farcovetsa.com",
  //     "name": "Stephanie",
  //     "lastName": "Guevara",
  //     "active": 1,
  //     "company": {
  //         "id": 133577,
  //         "code": "FARC",
  //         "name": "FARCOVET",
  //         "representative": "Franklin Íñiguez",
  //         "telephone": "(04) 606-0800"
  //     },
  //     "companyId": 133577,
  //     "roles": [
  //         {
  //             "id": 3,
  //             "role": "REPORT",
  //             "description": "Reportes"
  //         },
  //         {
  //             "id": 2,
  //             "role": "USER",
  //             "description": "Usuario"
  //         }
  //     ],
  //     "tokenAutentication": "5356"
  // }]
}

export async function findUsersByCompany(active, companyId) {
  return await RestGet("/api/user/findUser?active=" + active + "&companyId=" + companyId);
  //   return list of [    {
  //     "id": 106882,
  //     "email": "rbarahona@altvet.com.ec",
  //     "name": "Rodrigo",
  //     "lastName": "Barahona",
  //     "active": 1,
  //     "company": {
  //         "id": 103005,
  //         "code": "AVT",
  //         "name": "ALTVET",
  //         "representative": "Rodrigo Barahona",
  //         "telephone": "02-603-6149"
  //     },
  //     "companyId": 103005,
  //     "roles": [
  //         {
  //             "id": 3,
  //             "role": "REPORT",
  //             "description": "Reportes"
  //         },
  //         {
  //             "id": 2,
  //             "role": "USER",
  //             "description": "Usuario"
  //         }
  //     ],
  //     "tokenAutentication": "8592"
  // },]
}

export async function getUsersRoles() {
  return await RestGet("/api/user/roles");
  //   return list of [   {
  //     "id": 1,
  //     "role": "ADMIN",
  //     "description": "Administrador"
  // }]
}

export async function saleProductQuarterByCompanyAndQuarter(companyId, quarterId, year) {
  const route =
    "/api/saleProductQuarter/SaleProductQuarterByCompanyAndQuarter?companyId=" +
    companyId +
    "&quarterId=" +
    quarterId +
    "&year=" +
    year;
  return await RestGet(route);
}

export async function deleteSalesByQuarterYearAndCompany(companyId, quarterId, year) {
  const route =
    "/api/saleProductQuarter/deleteSalesByQuarterYearAndCompany?quarterId=" +
    quarterId +
    "&year=" +
    year +
    "&companyId=" +
    companyId;
  return await RestDelete(route);
}

export async function productsActiveByCompany(companyId) {
  return await RestGet("/api/product/productsActiveByCompany?companyId=" + companyId);
}

export async function saleProductQuarterUploadExcel(year, body) {
  return await RestPosMultiPartFile("/api/saleProductQuarter/uploadExcel?year=" + year, body);
}

export async function productUploadExcel(body) {
  return await RestPosMultiPartFile("/api/product/uploadExcel", body);
}

export async function storeUploadExcel(body) {
  return await RestPosMultiPartFile("/api/store/uploadExcel", body);
}

export async function deleteSaleProductQuarter(idSaleProductQuarter, body) {
  return await RestDelete(
    "/api/saleProductQuarter/deleteSaleProductQuarter?idSaleProductQuarter=" + idSaleProductQuarter,
    body
  );
}

export async function createUser(body) {
  // :param body : {
  //   "email": "noelalbertodg86@gmail.com",
  //   "password": "noelalbert",
  //   "name": "Noel",
  //   "lastName": "Diaz",
  //   "companyId": 1,
  //   "active": 1,
  //   "roles": [{
  //     "id": 1,
  //     "role": "ADMIN",
  //     "description": "Administrador"
  //   }, {
  //     "id": 2,
  //     "role": "USER",
  //     "description": "Usuario"
  //   }, {
  //     "id": 3,
  //     "role": "REPORT",
  //     "description": "Reportes"
  //   }]
  // }
  return await RestPost("/api/user/", body);
}

export async function updateUser(idUser, body) {
  // :param body : {
  //   "id": 174149,
  //   "email": "noelalbertodg86@gmail.com",
  //   "name": "Noel",
  //   "lastName": "Diaz Garcia",
  //   "companyId": 1,
  //   "active": 1,
  //   "roles": [{
  //     "id": 1,
  //     "role": "ADMIN",
  //     "description": "Administrador"
  //   }, {
  //     "id": 2,
  //     "role": "USER",
  //     "description": "Usuario"
  //   }, {
  //     "id": 3,
  //     "role": "REPORT",
  //     "description": "Reportes"
  //   }]
  // }
  return await RestPut("/api/user/updateUser?idUser=" + idUser, body);
}

export async function deleteUser(idUser) {
  return await RestDelete("/api/user/deleteUser?idUser=" + idUser);
}

export async function catalogsType() {
  return await RestGet("/api/catalog/catalogsType");
}

export async function catalogsByType(catalogTypeId) {
  return await RestGet("/api/catalog/catalogs?catalogTypeId=" + catalogTypeId);
  // return list of [
  //   {
  //     "id": 12,
  //     "name": "AVICULTURA",
  //     "abbreviation": "AVI",
  //     "catalogTypeId": 2
  // }
  // ]
}

export async function updateCatalog(body) {
  return await RestPut("/api/catalog/", body);
}

export async function createCatalog(body) {
  return await RestPost("/api/catalog/", body);
}

export async function deleteCatalog(idCatalog) {
  return await RestDelete("/api/catalog/deleteCatalogValue?idCatalog=" + idCatalog);
}

export async function productsByCompany(companyId) {
  return await RestGet("/api/product/productsByCompany?companyId=" + companyId);
}

export async function getFormCatalog() {
  return await RestGet("/api/catalog/catalogs?catalogTypeId=7");
  // return [
  //   {
  //       "id": 206,
  //       "name": "AEROSOL",
  //       "abbreviation": "AER",
  //       "catalogTypeId": 7
  //   }]
}

export async function Login(user, password) {
  return await RestPost("/requestLogin", { email: user, password: password });
}

export async function ConfirmLogin(user, code) {
  return await RestPost("/validateToken", { email: user, tokenAutentication: code });
}

export async function Logout() {
  //return await RestGet("/logout");
  return await RestGet("/login?logout");
}

export async function isLogin() {
  return await RestGet("/isLogin");
}

export async function getUserByEmail(email) {
  return await RestGet("/api/user/findUser?email=" + email);
  //   :return
  //   [
  //     {
  //         "id": 1,
  //         "email": "admin@aensaecuador.org",
  //         "name": "admin",
  //         "lastName": "admin",
  //         "active": 1,
  //         "company": {
  //             "id": 1,
  //             "code": "AEN",
  //             "name": "AENSA",
  //             "representative": "Francisco Troya",
  //             "telephone": "026009999"
  //         },
  //         "companyId": 1,
  //         "roles": [
  //             {
  //                 "id": 1,
  //                 "role": "ADMIN",
  //                 "description": "Administrador"
  //             },
  //             {
  //                 "id": 3,
  //                 "role": "REPORT",
  //                 "description": "Reportes"
  //             },
  //             {
  //                 "id": 2,
  //                 "role": "USER",
  //                 "description": "Usuario"
  //             }
  //         ],
  //         "tokenNewPassword": "19559d9d-b76d-4aac-83b6-032e531cb7c7",
  //         "tokenAutentication": "3393",
  //         "newPassword": "$2a$10$BV/F.hUIxppISDp9onXJ2ea3YNXfomm6pCYb1su/vwanEw8b5oIbC"
  //     }
  // ]
}

export async function getCurrentActiveUserInfo() {
  return await RestGet("/user");
  //   :returns
  //   {
  //     "authorities": [
  //         {
  //             "role": "ADMIN"
  //         },
  //         {
  //             "role": "REPORT"
  //         },
  //         {
  //             "role": "USER"
  //         }
  //     ],
  //     "details": {
  //         "remoteAddress": "107.171.197.101"
  //     },
  //     "authenticated": true,
  //     "principal": {
  //         "username": "admin@aensaecuador.org",
  //         "authorities": [
  //             {
  //                 "role": "ADMIN"
  //             },
  //             {
  //                 "role": "REPORT"
  //             },
  //             {
  //                 "role": "USER"
  //             }
  //         ],
  //         "accountNonExpired": true,
  //         "accountNonLocked": true,
  //         "credentialsNonExpired": true,
  //         "enabled": true,
  //         "companyId": 1
  //     }
  // }
}

export async function ResetPassword(user, oldPassword, newPassword) {
  const body = {
    username: user,
    newPassword: newPassword,
    confirmPassword: oldPassword
  };
  return await RestPost("/api/user/resetPassword/", body);
}

export async function updateRegisterSalesProduct(id, productId, year, quarterId, quantity, pvp) {
  const body = {
    id: id,
    productId: productId,
    year: year,
    quarterId: quarterId,
    quantity: quantity,
    pvp: pvp
  };
  return await RestPut(
    "/api/saleProductQuarter/updateSaleProductQuarter?idSaleProductQuarter=" + id,
    body
  );
}

export async function createRegisterSalesProduct(productId, year, quarterId, quantity, pvp) {
  const body = {
    id: 0,
    productId: productId,
    year: year,
    quarterId: quarterId,
    quantity: quantity,
    pvp: pvp
  };

  return await RestPost("/api/saleProductQuarter/", body);
}

export async function createProduct(
  name,
  code,
  presentation,
  administration,
  categoryId,
  sectorId,
  subSectorId,
  unitContent,
  groupId,
  companyId,
  manufacturer,
  formId,
  activeMolecularCompound
) {
  const body = {
    name: name,
    code: code,
    presentation: presentation,
    administration: administration,
    categoryId: categoryId,
    sectorId: sectorId,
    subSectorId: subSectorId,
    unitContent: unitContent,
    groupId: groupId,
    companyId: companyId,
    manufacturer: manufacturer,
    formId: formId,
    activeMolecularCompound: activeMolecularCompound
  };
  return await RestPost("/api/product/", body);
}

export async function desactivateProduct(idProduct) {
  return await RestDelete("/api/product/deleteProduct?idProduct=" + idProduct);
}

export async function activateProduct(idProduct) {
  return await RestPut("/api/product/activeProduct?idProduct=" + idProduct);
}

export async function editProduct(
  idProduct,
  name,
  code,
  presentation,
  administration,
  categoryId,
  sectorId,
  subSectorId,
  unitContent,
  groupId,
  companyId,
  manufacturer,
  formId,
  activeMolecularCompound
) {
  const body = {
    name: name,
    code: code,
    presentation: presentation,
    administration: administration,
    categoryId: categoryId,
    sectorId: sectorId,
    subSectorId: subSectorId,
    unitContent: unitContent,
    groupId: groupId,
    companyId: companyId,
    manufacturer: manufacturer,
    id: idProduct,
    formId: formId,
    activeMolecularCompound: activeMolecularCompound
  };
  return await RestPut("/api/product/updateProduct?idProduct=" + idProduct, body);
}

export async function getCatalogoReportType() {
  return await RestGet("/api/catalog/catalogs?catalogTypeId=10");
  //   return list of  [{
  //     "id": 237,
  //     "name": "Análisis de mercado",
  //     "abbreviation": "ADM",
  //     "catalogTypeId": 10
  // }]
}

export async function findAuditReport(reportType, user, ip, date, dateEnd) {
  let url = "/api/audit/findAuditReport/?report=true";
  if (date) {
    url += "&date=" + date; // 06/08/2023
  }
  if (dateEnd) {
    url += "&dateEnd=" + dateEnd; // 31/08/2023
  }
  if (user) {
    url += "&user=" + user;
  }
  if (reportType) {
    url += "&reportType=" + reportType;
  }
  if (ip) {
    url += "&ip=" + ip;
  }
  return await RestGet(url);

  // return list of [
  //   {
  //     "id": 32869,
  //     "ip": "181.112.9.70",
  //     "user": "admin@aensaecuador.org",
  //     "date": 1535509588590,
  //     "reportType": 229,
  //     "reportParams": "{\"tipoReporte\":null,\"nivelDetalle\":null,\"molecularCompound\":null,\"tipoDatos\":null,\"periodo\":null,\"productName\":null,\"sectorId\":null,\"groupId\":null,\"subsectorId\":null,\"categoryId\":null,\"year\":2018}"
  // }
  // ]
}

export async function deactivateStoreById(idStore) {
  return await RestDelete("/api/store/deactivateStoreById?idStore=" + idStore);
}

export async function activateStore(idStore) {
  return await RestPut("/api/store/activateStore?idStore=" + idStore);
}

export async function reportAnalysisVeterinaryMarketDetail(
  companyId,
  year,
  tipoReporte,
  nivelDetalle,
  tipoDatos,
  periodo,
  sectorsId,
  subsectorsId,
  groupsId,
  categoriesId
) {
  const url = "/api/report/reportAnalysisVeterinaryMarketDetail?companyId=" + companyId;
  const body = {
    tipoReporte,
    nivelDetalle,
    tipoDatos,
    periodo,
    sectorsId,
    subsectorsId,
    groupsId,
    categoriesId,
    year
  };
  return await RestPost(url, body, "");
}

export async function reportAnalysisVeterinaryMarketDetailCategory(
  categoryId,
  year,
  tipoReporte,
  nivelDetalle,
  tipoDatos,
  periodo,
  sectorsId,
  subsectorsId,
  groupsId,
  categoriesId
) {
  const url = "/api/report/reportAnalysisVeterinaryMarketDetailCategory?categoryId=" + categoryId;
  const body = {
    tipoReporte,
    nivelDetalle,
    tipoDatos,
    periodo,
    sectorsId,
    subsectorsId,
    groupsId,
    categoriesId,
    year
  };
  return await RestPost(url, body, "");
}
export async function superUploadExcel(body) {
  return await RestPosMultiPartFile("/api/sale/uploadExcel", body);
}

export async function notificacion(anio) {
  return await RestGet("/api/user/notificacion?anio=" + anio);
}
